export default {
	SET_BREADCRUMB(state, breadcrumb) {
		state.breadcrumb = breadcrumb;
	},

	SET_UNREADNOTIFICATIONS(state, notifications) {
		state.unreadNotifications = notifications;
	},

	REMOVE_UNREADNOTIFICATION(state, notification) {
		state.unreadNotifications = state.unreadNotifications.filter(
			notificationState => {
				return notificationState.pk !== notification.pk;
			}
		);
	},

	ADD_UNREADNOTIFICATION(state, notification) {
		if (state.unreadNotifications.length < 11) {
			state.unreadNotifications.unshift(notification);
			state.unreadNotifications.sort((notification1, notification2) => {
				if (notification1.criadoEm > notification2.criadoEm) {
					return -1;
				}

				if (notification1.criadoEm < notification2.criadoEm) {
					return 1;
				}
				return 0;
			});
		}
	},

	CLEAR_FILTROS_CALENDARIO_PRAZOS(state) {
		state.fitrosCalendarioPrazos = {
			responsaveis: [],
			status: [],
			apenasMeusSupervisionados: false
		};
	},
};
